<template>
  <v-container grid-list-lg fluid px-0 py-0 my-0 mx-0>
    <v-layout row wrap modal__block>
      <span class="modal__close" @click="closeModal"></span>

      <v-flex modal__wrapper xs12 :class="{ isBlocked: !editMode }">
        <v-layout row wrap>
          <h1 v-if="editMode">
            {{
              isCreate
                ? $t("components.client.add.licence.addLicense")
                : $t("components.client.add.licence.updateLicense")
            }}
          </h1>
          <h1 v-else>{{ $t("components.client.add.licence.title") }}</h1>
          <!-- <span @click="$router.go(-1)" class="goback">Вернуться назад</span> -->

          <v-flex xs12 v-if="licence">
            <v-form ref="form" v-model="valid">
              <v-layout form__row row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="licence.activity_type"
                    :label="$t('components.client.add.licence.kindOfActivity')"
                    :rules="rules.activity_type"
                    :disabled="!editMode && packageMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout form__row row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="licence.number"
                    :label="$t('components.client.add.licence.number')"
                    :rules="rules.number"
                    :disabled="!editMode && packageMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout form__row row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="licence.issued_by"
                    :label="$t('components.client.add.licence.issuedBy')"
                    :rules="rules.issued_by"
                    :disabled="!editMode && packageMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout form__row row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="licence.activity_list"
                    :label="$t('components.client.add.licence.activity_list')"
                    :rules="rules.activity_list"
                    :disabled="!editMode && packageMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout form__row row wrap>
                <v-flex xs6 sm6 md6>
                  <v-menu
                    ref="issued_at"
                    v-model="issuedAt"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="issued_at"
                        :label="$t('components.client.add.licence.issued_at')"
                        prepend-icon="event"
                        v-on="on"
                        v-on:blur="formatIssuedAt"
                        :rules="rules.issued_at"
                        v-mask="'##.##.####'"
                        :disabled="!editMode && packageMode"
                        return-masked-value
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="licence.issued_at"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1900-01-01"
                      @change="saveIssuedAt"
                      llocale="ru-ru"
                      first-day-of-week="1"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-menu
                    ref="end_at"
                    v-model="endAt"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="end_at"
                        :label="$t('components.client.add.licence.end_at')"
                        prepend-icon="event"
                        v-on="on"
                        v-on:blur="formatEndAt"
                        return-masked-value
                        v-mask="'##.##.####'"
                        :disabled="!editMode && packageMode"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="licence.end_at"
                      :min="new Date().toISOString().substr(0, 10)"
                      max="2050-01-01"
                      @change="saveEndAt"
                      llocale="ru-ru"
                      first-day-of-week="1"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-layout row wrap form__row>
                <v-flex xs12>
                  <div class="licence__upload mr-3" @click="fileDialog = true">
                    <v-icon class="mr-2">cloud_upload</v-icon>
                    {{
                      licence.file
                        ? $t("components.client.add.licence.updateFile")
                        : $t("components.client.add.licence.addFile")
                    }}
                  </div>

                  <strong v-if="licence && licence.file"
                    >{{ $t("components.client.add.licence.uploadedFile") }}:
                    {{ licence.file.name }}</strong
                  >
                </v-flex>
              </v-layout>

              <v-layout form__row row wrap v-if="packageMode || editMode">
                <v-flex xs12>
                  <v-btn color="primary" @click="validate" class="mt-4 ml-0">{{
                    isCreate
                      ? $t("components.client.add.licence.addLicense")
                      : $t("components.client.add.licence.updateLicense")
                  }}</v-btn>
                </v-flex>
              </v-layout>
            </v-form>

            <v-dialog v-model="fileDialog" width="500">
              <v-layout row wrap modal>
                <v-flex xs12 modal__wrapper>
                  <form
                    enctype="multipart/form-data"
                    novalidate
                    v-if="isInitial || isSaving"
                  >
                    <h2 class="mb-4">{{ $t("components.client.add.licence.fileDialog.title") }}</h2>
                    <div class="dropbox">
                      <input
                        type="file"
                        multiple
                        :name="uploadFieldName"
                        :disabled="isSaving"
                        @change="
                          filesChange($event.target.name, $event.target.files);
                          fileCount = $event.target.files.length;
                        "
                        class="input-file"
                      />
                      <p v-if="isInitial" v-html="$t('components.client.add.licence.fileDialog.dropZoneHtml')">
                      </p>
                      <p v-if="isSaving">{{$t('components.client.add.licence.fileDialog.uploadCount', {count: fileCount})}}</p>
                    </div>
                  </form>

                  <!--SUCCESS-->
                  <div v-if="isSuccess">
                    <h2>{{ $t("components.client.add.licence.fileDialog.success") }}</h2>
                  </div>
                  <!--FAILED-->
                  <div v-if="isFailed">
                    <h2>{{ $t("components.client.add.licence.fileDialog.failed") }}</h2>
                    <p>
                      <a href="javascript:void(0)" @click="reset()"
                        >{{ $t("components.client.add.licence.fileDialog.more") }}</a
                      >
                    </p>
                    <pre>{{ uploadError }}</pre>
                  </div>
                </v-flex>
              </v-layout>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import {
  uploadLicence,
  uploadPublicDocument,
} from "@/components/lib/file-upload.service";
import rules from "@/utils/data/rules";
import { mask } from "vue-the-mask";
import LicenseModel from "@/models/LicenseModel";
import showNotify from "@/services/noty";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  name: "AddLicence",
  directives: { mask },
  data: () => ({
    valid: false,
    licence: null,
    fileDialog: false,
    uploadedFiles: null,
    uploadError: null,
    currentStatus: null,
    uploadFieldName: "",
    uploadFieldId: null,
    issuedAt: false,
    issued_at: "",
    endAt: false,
    end_at: "",
    rules,
  }),
  props: {
    publicHash: {
      type: String,
      default: null,
    },
    editedLicence: {
      type: Object,
    },
    isCreate: {
      type: Boolean,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    packageMode: {
      // type: Boolean,
      default: 0,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    isCreate(val) {
      if (!val) {
        this.licence = Object.assign({}, this.editedLicence);
        this.deFormatIssuedAt();
        this.deFormatEndAt();
      } else {
        this.licence = new LicenseModel();
        this.$refs.form.reset();
      }
    },
    issuedAt(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    endAt(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  computed: {
    isFilled() {
      return !!this.manager.name;
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  mounted() {
    if (this.isCreate && this.editedLicence) {
      this.licence = new LicenseModel();
    } else {
      this.licence = Object.assign({}, this.editedLicence);
      this.deFormatIssuedAt();
      this.deFormatEndAt();
    }
    this.reset();
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveLicence();
      }
    },
    async saveLicence() {
      const data = this.licence;
      const method = "POST";
      const inn = this.agentMode ? this.agentMode : false;

      if (this.packageMode) {
        let url = "";
        if (this.publicHash) {
          url = this.isCreate
            ? `v1/licenses/save-by-hash/${this.publicHash}`
            : `v1/licenses/${this.licence.id}/save-by-hash/${this.publicHash}`;
        } else {
          url = "v1/validate";
        }
        const params = this.publicHash ? null : { model: "licenses", inn };

        await apiCallTrue({
          url,
          method,
          data,
          params,
        })
          .then((response) => {
            if (this.isCreate) {
              this.$emit("addLicence", response.data.data);
            } else {
              this.updateLicences(response.data.data);
            }
            this.licence = {};
          })
          .catch((error) => {
            showNotify("error", error);
            this.errors = error;
          });
      } else {
        const url = this.licence.id
          ? `v1/licenses/${this.licence.id}`
          : `v1/licenses`;
        await apiCallTrue({
          url,
          method,
          data,
        })
          .then((response) => {
            if (this.isCreate) {
              this.$emit("addLicence", response.data.data);
            } else {
              this.updateLicences(response.data.data);
            }
            this.licence = {};
          })
          .catch((error) => {
            showNotify("error", error);
            this.errors = error;
          });
      }
    },
    reset() {
      this.currentStatus = STATUS_INITIAL;
      // this.uploadedFiles = {};
      this.uploadError = null;
    },
    saveFile(formData) {
      this.currentStatus = STATUS_SAVING;
      const config = { inn: this.agentMode, hash: this.publicHash };

      if (this.publicHash) {
        uploadPublicDocument(formData, config)
          .then((response) => {
            if (response && response.result) {
              this.licence.file = response.data.file;
              this.currentStatus = STATUS_SUCCESS;
              this.licence.id = response.data.id;
              // this.$emit("updateLicences");
              this.$emit("addLicenceFile", {
                file: response.data,
                licence: this.licence,
              });
              setTimeout(() => (this.fileDialog = false), 2000);
              setTimeout(() => this.reset(), 3000);
            } else {
              this.uploadError = [];
              this.uploadError[0] = response.message;
              this.currentStatus = STATUS_FAILED;
            }
          })
          .catch((error) => {
            this.uploadError = error.response.data.validation;
            this.currentStatus = STATUS_FAILED;
          });
      } else {
        uploadLicence(formData, config)
          .then((response) => {
            this.licence.file = response.data.file;
            this.currentStatus = STATUS_SUCCESS;
            this.licence.id = response.data.id;
            // this.$emit("updateLicences");
            this.$emit("addLicenceFile", {
              file: response.data,
              licence: this.licence,
            });
            setTimeout(() => (this.fileDialog = false), 2000);
            setTimeout(() => this.reset(), 3000);
          })
          .catch((err) => {
            this.uploadError = err.response;
            this.currentStatus = STATUS_FAILED;
          });
      }
    },
    filesChange(fieldName, fileList) {
      const formData = new FormData();

      if (!fileList.length) return;

      formData.append("type", 2);
      formData.append("file", fileList[0]);

      if (this.licence.id) {
        formData.append("licence_id", this.licence.id);
      }

      this.saveFile(formData);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    saveIssuedAt(date) {
      this.$refs.issued_at.save(date);
      this.deFormatIssuedAt();
    },
    formatIssuedAt() {
      if (this.issued_at) {
        this.licence.issued_at = this.issued_at
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatIssuedAt() {
      if (this.licence.issued_at) {
        this.issued_at = this.licence.issued_at
          .split("-")
          .reverse()
          .join(".");
      }
    },
    saveEndAt(date) {
      this.$refs.end_at.save(date);
      this.deFormatEndAt();
    },
    formatEndAt() {
      if (this.end_at) {
        this.licence.end_at = this.end_at
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatEndAt() {
      if (this.licence.end_at) {
        this.end_at = this.licence.end_at
          .split("-")
          .reverse()
          .join(".");
      }
    },
    updateLicences(licence) {
      console.log(licence, "licen");
      this.$emit("updateLicences", licence);
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="scss">
.licence {
  &__upload {
    display: inline-block;
    vertical-align: top;
    border: 1px solid #ccc;
    border-radius: 4px;
    line-height: 20px;
    padding: 3px 10px;
    cursor: pointer;

    .v-icon {
      line-height: 18px;
    }

    + strong {
      line-height: 30px;
    }
  }
}
</style>
